import { render, staticRenderFns } from "./MxInfoModal.vue?vue&type=template&id=a2c855e2"
import script from "./MxInfoModal.vue?vue&type=script&lang=ts"
export * from "./MxInfoModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports